import React from "react";

const VendorQuotes = () => {
  return <div>MyQuotes</div>;
};

export default VendorQuotes;
